import React from 'react';

import Text from './components/Text';
import Stub from './components/Stub';

import {componentsMap} from './config';

/**
 * Represents ComponentsFactory
 */
class ComponentsFactory {
	/**
	 * Returns a React component according to the type
	 * @param {string} type Type of component to return
	 * @returns {React.FC}
	 */
	create(type: keyof typeof componentsMap): React.FC {
		if (typeof componentsMap[type] !== 'undefined') {
			return componentsMap[type] as React.FC;
		}

		// Default
		if (type && (type.startsWith('Text') || type.endsWith('Text'))) {
			return Text;
		}

		return Stub as React.FC;
	}
}

export default new ComponentsFactory();
